import _toConsumableArray from "/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createForOfIteratorHelper from "/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var t = /*#__PURE__*/function () {
  function t() {
    var _t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, t);

    this.t = _t, this.i = new ("undefined" != typeof TextEncoder ? TextEncoder : require("util").TextEncoder)();
  }

  _createClass(t, [{
    key: "encode",
    value: function encode(t) {
      var r = this.h(t),
          e = r.reduce(function (t, r) {
        return t + r.byteLength;
      }, 0),
          s = new Uint8Array(e),
          i = {
        array: s,
        view: new DataView(s.buffer)
      };
      var n = 0;

      var _iterator = _createForOfIteratorHelper(r),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t2 = _step.value;
          _t2.storer(i, n), n += _t2.byteLength;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return s.buffer;
    }
  }, {
    key: "h",
    value: function h(t) {
      var r = this.u(t);
      return [this.o(r)].concat(_toConsumableArray(this.l(t, r)));
    }
  }, {
    key: "l",
    value: function l(t, r) {
      var e, s;

      switch (r) {
        case "C":
          return e = t.charCodeAt(), [this.p(function (_ref, r) {
            var t = _ref.view;
            return t.setInt8(r, e);
          }, 1)];

        case "S":
          return s = this.i.encode(t), [].concat(_toConsumableArray(this.h(s.byteLength)), [this.A(s)]);

        case "i":
          return [this.p(function (_ref2, e) {
            var r = _ref2.view;
            return r.setInt8(e, t);
          }, 1)];

        case "U":
          return [this.p(function (_ref3, e) {
            var r = _ref3.view;
            return r.setUint8(e, t);
          }, 1)];

        case "I":
          return [this.p(function (_ref4, e) {
            var r = _ref4.view;
            return r.setInt16(e, t);
          }, 2)];

        case "l":
          return [this.p(function (_ref5, e) {
            var r = _ref5.view;
            return r.setInt32(e, t);
          }, 4)];

        case "d":
          return [this.p(function (_ref6, e) {
            var r = _ref6.view;
            return r.setFloat32(e, t);
          }, 4)];

        case "D":
          return [this.p(function (_ref7, e) {
            var r = _ref7.view;
            return r.setFloat64(e, t);
          }, 8)];

        case "[":
          return this._(t);

        case "{":
          return this.v(t);
      }

      return [];
    }
  }, {
    key: "u",
    value: function u(t) {
      if (null === t) return "Z";

      switch (typeof t) {
        case "undefined":
          return "N";

        case "boolean":
          return t ? "T" : "F";

        case "string":
          return 1 === t.length && t.charCodeAt() <= 127 ? "C" : "S";

        case "number":
          if (Number.isInteger(t)) {
            if (-128 <= t && t <= 127) return "i";
            if (0 <= t && t <= 255) return "U";
            if (-32768 <= t && t <= 32767) return "I";
            if (-2147483648 <= t && t <= 2147483647) return "l";
          }

          return Number.isNaN(t) || Math.fround(t) === t ? "d" : "D";

        case "object":
          return Array.isArray(t) || ArrayBuffer.isView(t) ? "[" : "{";
      }

      throw Error("Value cannot be serialized");
    }
  }, {
    key: "_",
    value: function _(t) {
      var _this = this;

      var r;
      if ((!0 === this.t.optimizeArrays || "onlyTypedArrays" === this.t.optimizeArrays) && ArrayBuffer.isView(t)) switch (t.constructor.name) {
        case "Int8Array":
          return [].concat(this.I("i", t.length), this.A(t));

        case "Uint8Array":
          return [].concat(this.I("U", t.length), this.A(t));

        case "Int16Array":
          r = "I";
          break;

        case "Int32Array":
          r = "l";
          break;

        case "Float32Array":
          r = "d";
          break;

        case "Float64Array":
          r = "D";
      }
      var e = (Array.isArray(t) ? t : Array.from(t)).map(function (t) {
        return {
          type: r || _this.u(t),
          value: t
        };
      });
      return this.U(e, "]", r || !0 === this.t.optimizeArrays);
    }
  }, {
    key: "v",
    value: function v(t) {
      var _this2 = this;

      var r = Object.entries(t).map(function (t) {
        return {
          key: t[0],
          type: _this2.u(t[1]),
          value: t[1]
        };
      });
      return this.U(r, "}", !0 === this.t.optimizeObjects);
    }
  }, {
    key: "I",
    value: function I(t, r) {
      var e = [];
      return null != r && (t && e.push(this.o("$"), this.o(t)), e.push.apply(e, [this.o("#")].concat(_toConsumableArray(this.h(r))))), e;
    }
  }, {
    key: "U",
    value: function U(t, r, e) {
      var s, i;
      e && (t.length && (s = this.k(t)), i = t.length);
      var n = this.I(s, i);

      var _iterator2 = _createForOfIteratorHelper(t),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _r = _step2.value;
          null != _r.key && "N" !== _r.type && n.push.apply(n, _toConsumableArray(this.l(_r.key, "S"))), !s && n.push(this.o(_r.type)), n.push.apply(n, _toConsumableArray(this.l(_r.value, s || _r.type)));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return null == i && n.push(this.o(r)), n;
    }
  }, {
    key: "k",
    value: function k(t) {
      var r = t.map(function (t) {
        return t.type;
      }).reduce(this.T);
      return "U" === r && t.some(function (t) {
        return t.value < 0;
      }) ? "I" : r;
    }
  }, {
    key: "T",
    value: function T(t, r) {
      if (t === r) return t;
      if (!t) return null;

      var e = function e(_e) {
        return _e[Math.min(_e.indexOf(t), _e.indexOf(r))];
      };

      return e("Dd") || e("SC") || e("lIUi");
    }
  }, {
    key: "o",
    value: function o(t) {
      return this.p(function (_ref8, e) {
        var r = _ref8.view;
        return r.setInt8(e, t.charCodeAt());
      }, 1);
    }
  }, {
    key: "A",
    value: function A(t) {
      return this.p(function (_ref9, e) {
        var r = _ref9.array;
        return r.set(t, e);
      }, t.byteLength);
    }
  }, {
    key: "p",
    value: function p(t, r) {
      return {
        storer: t,
        byteLength: r
      };
    }
  }]);

  return t;
}();

var r = /*#__PURE__*/function () {
  function r() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, r);

    this.t = t, this.g = new ("undefined" != typeof TextDecoder ? TextDecoder : require("util").TextDecoder)();
  }

  _createClass(r, [{
    key: "decode",
    value: function decode(t) {
      var r = new Uint8Array(t),
          e = new DataView(r.buffer);
      return this.D = {
        array: r,
        view: e
      }, this.S = 0, this.C();
    }
  }, {
    key: "C",
    value: function C() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.m(!1);

      switch (t) {
        case "Z":
          return null;

        case "N":
          return;

        case "T":
          return !0;

        case "F":
          return !1;

        case "i":
          return this.F(function (_ref10, r) {
            var t = _ref10.view;
            return t.getInt8(r);
          }, 1);

        case "U":
          return this.F(function (_ref11, r) {
            var t = _ref11.view;
            return t.getUint8(r);
          }, 1);

        case "I":
          return this.F(function (_ref12, r) {
            var t = _ref12.view;
            return t.getInt16(r);
          }, 2);

        case "l":
          return this.F(function (_ref13, r) {
            var t = _ref13.view;
            return t.getInt32(r);
          }, 4);

        case "L":
          return this.N(8, this.t.int64Handling, !0);

        case "d":
          return this.F(function (_ref14, r) {
            var t = _ref14.view;
            return t.getFloat32(r);
          }, 4);

        case "D":
          return this.F(function (_ref15, r) {
            var t = _ref15.view;
            return t.getFloat64(r);
          }, 8);

        case "H":
          return this.N(this.V(), this.t.highPrecisionNumberHandling, !1);

        case "C":
          return String.fromCharCode(this.C("i"));

        case "S":
          return this.j(this.V());

        case "[":
          return this.M();

        case "{":
          return this.O();
      }

      throw Error("Unexpected type");
    }
  }, {
    key: "Z",
    value: function Z() {
      var t, r;

      switch (this.m(!0)) {
        case "$":
          if (this.q(), t = this.m(!1), "#" !== this.m(!0)) throw Error("Expected count marker");

        case "#":
          this.q(), r = this.V();
      }

      return {
        type: t,
        count: r
      };
    }
  }, {
    key: "M",
    value: function M() {
      var _this3 = this;

      var _this$Z = this.Z(),
          t = _this$Z.type,
          r = _this$Z.count;

      if (-1 !== "ZTF".indexOf(t)) return Array(r).fill(this.C(t));
      if (this.t.useTypedArrays) switch (t) {
        case "i":
          return this.B(r);

        case "U":
          return this.L(r);

        case "I":
          return Int16Array.from({
            length: r
          }, function () {
            return _this3.C(t);
          });

        case "l":
          return Int32Array.from({
            length: r
          }, function () {
            return _this3.C(t);
          });

        case "d":
          return Float32Array.from({
            length: r
          }, function () {
            return _this3.C(t);
          });

        case "D":
          return Float64Array.from({
            length: r
          }, function () {
            return _this3.C(t);
          });
      }

      if (null != r) {
        var _e2 = Array(r);

        for (var _s = 0; _s < r; _s++) {
          _e2[_s] = this.C(t);
        }

        return _e2;
      }

      {
        var _t3 = [];

        for (; "]" !== this.m(!0);) {
          _t3.push(this.C());
        }

        return this.q(), _t3;
      }
    }
  }, {
    key: "O",
    value: function O() {
      var _this$Z2 = this.Z(),
          t = _this$Z2.type,
          r = _this$Z2.count,
          e = {};

      if (null != r) for (var _s2 = 0; _s2 < r; _s2++) {
        e[this.C("S")] = this.C(t);
      } else {
        for (; "}" !== this.m(!0);) {
          e[this.C("S")] = this.C();
        }

        this.q();
      }
      return e;
    }
  }, {
    key: "V",
    value: function V() {
      var t = this.C();
      if (Number.isInteger(t) && t >= 0) return t;
      throw Error("Invalid length/count");
    }
  }, {
    key: "N",
    value: function N(t, r, e) {
      if ("function" == typeof r) return this.F(r, t);

      switch (r) {
        case "skip":
          return void this.q(t);

        case "raw":
          return e ? this.L(t) : this.j(t);
      }

      throw Error("Unsuported type");
    }
  }, {
    key: "L",
    value: function L(t) {
      return this.F(function (_ref16, e) {
        var r = _ref16.array;
        return new Uint8Array(r.buffer, e, t);
      }, t);
    }
  }, {
    key: "B",
    value: function B(t) {
      return this.F(function (_ref17, e) {
        var r = _ref17.array;
        return new Int8Array(r.buffer, e, t);
      }, t);
    }
  }, {
    key: "j",
    value: function j(t) {
      var _this4 = this;

      return this.F(function (_ref18, e) {
        var r = _ref18.array;
        return _this4.g.decode(new DataView(r.buffer, e, t));
      }, t);
    }
  }, {
    key: "q",
    value: function q() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.R(t), this.S += t;
    }
  }, {
    key: "m",
    value: function m(t) {
      var _this$D = this.D,
          r = _this$D.array,
          e = _this$D.view;
      var s = "N";

      for (; "N" === s && this.S < r.byteLength;) {
        s = String.fromCharCode(e.getInt8(this.S++));
      }

      return t && this.S--, s;
    }
  }, {
    key: "F",
    value: function F(t, r) {
      this.R(r);
      var e = t(this.D, this.S, r);
      return this.S += r, e;
    }
  }, {
    key: "R",
    value: function R(t) {
      if (this.S + t > this.D.array.byteLength) throw Error("Unexpected EOF");
    }
  }]);

  return r;
}();

function e(r, e) {
  return new t(e).encode(r);
}

function s(t, e) {
  return new r(e).decode(t);
}

var i = {
  encode: e,
  decode: s
};
export { i as Ubjson, r as UbjsonDecoder, t as UbjsonEncoder, s as decode, e as encode };